// extracted by mini-css-extract-plugin
export default {"settingsContainer":"style_settingsContainer__+-DDG","logo":"style_logo__T12Ob"};